// extracted by mini-css-extract-plugin
export var link = "index-module--link--H4C+1";
export var root = "index-module--root--dJh2f";